<template>
    <div class="custom-report-line" :data-id="id" :data-layout-type="gConsts.node.layout.types.CUSTOM_LINE" 
        :data-is-focused="isFocused ? 'true' : 'false'" 
        :data-can-edit="canEdit ? 'true' : 'false'"
        :style="{
            '--custom-line-color': reportCustomLine.layout.color
        }">

        <!-- Modo visualização -->
        <div v-if="!isEditingReportText" class="custom-report-line__content">
            <span :data-can-edit="canEdit ? 'true' : 'false'" class="custom-report-line__text" 
                @click="activateEditMode">
                <span v-if="!inputText" class="placeholder">Digite livremente</span>
                <report-line-text :text="inputText" class="line"></report-line-text>
                <!-- <span v-show="locationsString.length > 0" class="locations">{{ locationsString }}</span> -->
            </span>
            <button 
                v-if="canDelete"
                class="button--remove"
                @click="onRemoveCustomLineFromReport"
                title="Remover linha do relatório"
            >
                <TrashCanIconSvg />
            </button>
        </div>  

        <!-- Modo de edição (WORK) -->
        <template v-if="isEditingReportText">
            <span class="custom-report-line__text">
                <custom-line-input :value="inputText" 
                    @input="onUpdateInputText" @blur="onBlur" :autoFocus="true" :disabled="!canEdit" />
            </span>
        </template>
    </div>
</template>

<script>
import { gConsts } from '@/globals/gConsts';
import { mapActions, mapGetters } from 'vuex';

import reportLineText from '@/features/report/components/text/reportLineText.vue';
import customLineInput from '@/features/report/components/input/customReportLineInput.vue';

import TrashCanIconSvg from '@/assets/icons/trash-can.svg';

export default {
    name: 'customReportLineCMP',
    components: {
        customLineInput,
        reportLineText,
        TrashCanIconSvg,
    },
    props: {
        id: {
            type: String,
            required: false
        },
        reportCustomLine: {
            type: Object,
            required: true
        },
        execMode: {
            type: String,
            default: gConsts.rt.execModes.WORK
        },
        canEdit: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            gConsts: gConsts,
            isFocused: false,
            isEditingReportText: false,
            inputText: this.reportCustomLine.reportText || '',
        }   
    },

    watch: {
        reportCustomLine: {
            handler(newVal) {
                this.inputText = newVal.reportText || '';
            },
            immediate: true,
            deep: true,
        },
    },

    computed: {
        ...mapGetters([
            'GET_lastAddedCustomLineId',  
        ]),

        canDelete() {
            // TODO: Adicionar verificacao de permissoes por usuario acessado depois (Clinica/dentista).
            return this.execMode == gConsts.rt.execModes.WORK && this.canEdit;
        }
    },

    methods: {
        ...mapActions([
            'ACT_report_removeCustomLineText',
            'ACT_report_updateCustomLineText',
        ]),

        onUpdateInputText(value) {
            this.inputText = value;
        },

        onRemoveCustomLineFromReport() {
            this.ACT_report_removeCustomLineText({ customLineId: this.reportCustomLine.id });
        },

        activateEditMode() {
            if (!this.canEdit)
                return;
            this.isEditingReportText = true;
            this.isFocused = true;
        },

        onFocus() {
            this.isFocused = true;
        },

        onBlur() {
            this.isEditingReportText = false;
            this.isFocused = false;
            // Remove linha do relatorio caso apague todo texto
            if (this.inputText.length == 0) {
                this.ACT_report_removeCustomLineText({ customLineId: this.reportCustomLine.id });
            } else {
                this.ACT_report_updateCustomLineText({ customLineId: this.reportCustomLine.id, text: this.inputText });
            }
        },

    },

    mounted() {
        if (this.GET_lastAddedCustomLineId == this.reportCustomLine.id && !this.inputText) {
            this.$nextTick(() => {
                this.activateEditMode();
            });
        }
    },
}
</script>

<style scoped>
@import '../../styles/shared/reportLine/custom_report_line.css';

.custom-report-line {
    position: relative;
}

.custom-report-line__content > .button--remove {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--color-dark-gray);
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.custom-report-line__content > .button--remove:hover:not(:disabled) {
    color: var(--color-error);
}

.custom-report-line__content > .button--remove:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.custom-report-line__content > .button--remove svg {
    width: 14px;
    height: 14px;
}

.custom-report-line[data-can-edit="false"] {
    cursor: default;
}

.custom-report-line[data-can-edit="true"] .custom-report-line__text[data-can-edit="true"] .line:hover {
    opacity: 0.7 !important;
    cursor: text;
    /* text-decoration: underline; */
}

.custom-report-line__text .placeholder {
    display: inline-block;
    width: stretch;
    color: var(--color-secondary);
    border-bottom: 1px solid var(--color-gray);
    opacity: 0.5;
    transition: all 0.2s ease;
    line-height: var(--leading-normal);
    cursor: text;
}

/** Relatorio */
#relatorio[data-exec-mode="work"] .custom-report-line {
    border-left: 3px solid var(--custom-line-color, #ccc);
    padding-left: var(--spacing-sm);
    padding-block: var(--spacing-sm);
}

</style>